if (!customElements.get("signature-kits")) {
  class SignatureKits extends HTMLElement {
    connectedCallback() {
      this.pixDiscount = parseFloat(this.dataset.pixDiscount) || 0;
      this.installments = parseInt(this.dataset.installments, 10) || 1;
      this.interest = Math.max(1, parseFloat(this.dataset.interest) || 1);
      this.noHover = window.matchMedia("(hover: none)");
      this.cards = Array.from(this.querySelectorAll("[data-sk-card]"));

      this.cards.forEach((card) => this.initCard(card));

      // clique fora dos cards desativa (mobile)
      this.onDocClick = (e) => {
        if (this.noHover.matches && !e.target.closest("[data-sk-card]")) this.deactivateAll();
      };
      document.addEventListener("click", this.onDocClick);
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.onDocClick);
    }

    initCard(card) {
      // tocar no card ativa (apenas em touch / sem hover; no desktop o hover cuida disso)
      card.addEventListener("click", (e) => {
        if (
          e.target.closest("label.m-skp") ||
          e.target.closest("[data-sk-add]") ||
          e.target.closest("[data-sk-seekit]")
        ) {
          return;
        }
        if (this.noHover.matches && !card.classList.contains("is-active")) {
          this.deactivateAll();
          card.classList.add("is-active");
          e.stopPropagation();
        }
      });

      // marcar/desmarcar produto recalcula o total
      card.querySelectorAll("[data-sk-check]").forEach((chk) => {
        chk.addEventListener("change", () => this.recompute(card));
      });

      // adicionar ao carrinho
      const addBtn = card.querySelector("[data-sk-add]");
      if (addBtn) {
        addBtn.addEventListener("click", (e) => {
          e.preventDefault();
          this.addToCart(card, addBtn);
        });
      }

      this.recompute(card);
    }

    deactivateAll() {
      this.cards.forEach((c) => c.classList.remove("is-active"));
    }

    checkedRows(card) {
      return Array.from(card.querySelectorAll("label.m-skp")).filter((row) => {
        if (row.dataset.skAvailable === "false") return false;
        const chk = row.querySelector("[data-sk-check]");
        return chk && chk.checked && !chk.disabled;
      });
    }

    showError(card, message) {
      const box = card.querySelector("[data-sk-error]");
      if (!box) return;
      box.textContent = message || "Não foi possível adicionar ao carrinho. Tente novamente.";
      box.hidden = false;
    }

    hideError(card) {
      const box = card.querySelector("[data-sk-error]");
      if (box) box.hidden = true;
    }

    // recalcula total/PIX/parcela do card a partir dos produtos marcados
    recompute(card) {
      this.hideError(card);
      const checked = this.checkedRows(card);
      const total = checked.reduce((sum, row) => sum + (parseInt(row.dataset.skPrice, 10) || 0), 0);

      const pay = card.querySelector(".m-signature-kits__info .m-pay");
      if (pay) this.renderPay(pay, total);

      const addBtn = card.querySelector("[data-sk-add]");
      if (addBtn) addBtn.disabled = checked.length === 0;
    }

    renderPay(pay, total) {
      const full = pay.querySelector(".m-pay__full");
      const pix = pay.querySelector(".m-pay__pix");
      const inst = pay.querySelector(".m-pay__installment");
      const showPix = this.pixDiscount > 0;
      const pixPrice = total - Math.round((total * this.pixDiscount) / 100); // arredonda o desconto, igual ao checkout da Luna
      const per = Math.round((total * this.interest) / this.installments);

      if (full) full.textContent = this.money(total) + (showPix ? "/" : "");
      if (pix) pix.textContent = this.money(pixPrice) + " no Pix";
      if (inst) {
        inst.textContent = this.installments + "x de " + this.money(per) + (this.interest <= 1 ? " sem juros" : "");
      }
    }

    // formata centavos no padrão da loja (R$ 1.234,56)
    money(cents) {
      return "R$ " + (cents / 100).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    addToCart(card, button) {
      const items = this.checkedRows(card)
        .map((row) => ({ id: row.dataset.skVariant, quantity: 1 }))
        .filter((item) => item.id);
      if (!items.length) return;

      const { MinimogSettings } = window;
      if (!MinimogSettings || typeof fetchConfig !== "function") {
        this.showError(card);
        return;
      }
      const cartDrawer = document.querySelector("m-cart-drawer");

      // coleta as sections do carrinho pra re-render (mesmo padrão do product-bundles)
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections } })
      );

      const config = fetchConfig("javascript");
      config.method = "POST";
      config.body = JSON.stringify({ items, sections, sections_url: window.location.pathname });

      this.toggleLoading(button, true);
      fetch(`${MinimogSettings.routes.cart_add_url}`, config)
        .then((r) => r.json())
        .then((response) => {
          if (response.status) {
            // erro do /cart/add: mostra a mensagem no painel do card (antes era falha silenciosa)
            this.showError(card, response.description || response.message);
            document.dispatchEvent(
              new CustomEvent("product-ajax:error", { detail: { errorMessage: response.description } })
            );
            return;
          }

          this.hideError(card);
          if (MinimogSettings.use_ajax_atc) {
            if (cartDrawer && MinimogSettings.enable_cart_drawer) {
              // QA 2026-07-13: sem notificação de sucesso no drawer (o drawer abrir já é o feedback)
              if (typeof cartDrawer.open === "function") cartDrawer.open();
            }
            if (window.MinimogEvents && window.MinimogTheme) {
              window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
            }
            document.dispatchEvent(new CustomEvent("product-ajax:added", { detail: { product: response } }));
          } else {
            window.location = MinimogSettings.routes.cart;
          }
        })
        .catch((err) => {
          console.error("signature-kits add error:", err);
          this.showError(card);
        })
        .finally(() => this.toggleLoading(button, false));
    }

    toggleLoading(button, loading) {
      if (!button) return;
      button.classList.toggle("m-spinner-loading", loading);
      button.disabled = loading;
    }
  }

  customElements.define("signature-kits", SignatureKits);
}
